import { ConfiguratorField } from './types';
import { privateApiWithRouteLeavingCancelation } from '../ApiService/ApiServiceWithRouteLeavingCancelation';

const cancelableFetchConfiguratorFields = async (jobGroupId: string): Promise<ConfiguratorField[]> =>
    privateApiWithRouteLeavingCancelation.getWithAbortControl<ConfiguratorField[]>(
        `job-groups/${jobGroupId}/importer-configurator-fields`,
    );

export const CancelableConfiguratorFieldGateway = {
    cancelableFetchConfiguratorFields,
};
